module.exports = __webpack_public_path__ + "static/media/degas-8.dc64c519.jpeg";